var _path, _path2, _g, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeb3World(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 35.512 35.591",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      paintOrder: "fill",
      fill: "rgb(13, 84, 78)"
    },
    cx: 17.717,
    cy: 17.764,
    rx: 17.728,
    ry: 17.728
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 17.956 9.649 L 19.913 9.649 L 22.483 23.26 L 22.756 23.26 L 21.707 29.093 L 19.476 29.093 L 17.015 16.037 L 16.742 16.037 L 17.956 9.649 Z",
    fill: "#09C790"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.956 9.649 L 19.913 9.649 L 22.483 23.26 L 22.756 23.26 L 21.707 29.093 L 19.476 29.093 L 17.015 16.037 L 16.742 16.037 L 17.956 9.649 Z",
    fill: "url(#paint0_linear_166_1290)",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5.28301, 7.648536)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 14.475 2 L 10.782 21.405 L 10.794 21.444 L 3.964 21.444 L 0 2 L 5.058 2 L 7.519 15.611 L 7.792 15.611 L 10.362 2 L 14.475 2 Z",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 21.674 29.093 L 25.191 9.649 L 30.239 9.649 L 26.275 29.093 L 21.674 29.093 Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_166_1290",
    x1: 12.0602,
    y1: 5.13226,
    x2: 17.8832,
    y2: 5.99107,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1, 0, 0, 1, 5.28301, 7.648536)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05382A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09C790"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb3World);
export default __webpack_public_path__ + "static/media/web3-world.374281f24e9f3f976d7cebca5e9a8552.svg";
export { ForwardRef as ReactComponent };